$bog_merchquarium_app $mol_page
	Settings_title @ \Settings
	Return_title @ \Return
	Kind_all @ \Merch kind
	Fandom_all @ \Fandoms
	title @ \Catalog 
	seo_server \https://cmyser-ru-merchquarium.91.188.212.151.ip.giper.dev/
	Product_card* $bog_merchquarium_product_card
		product_link <= product_link* \
		catalog_link <= catalog_link \
		search? <=> search? \
		cart_count? <=> cart_count*? 0
		product_delete? <=> product_delete*? null
		editable <= editing true
	Social* $mol_link
		uri <= social_uri* \
		target \_blank
		hint <= social_uri* \
		sub <= social_sub* /
	Icon_telegram* $mol_icon_telegram
	Icon_vk* $mol_icon_vk
	Icon_youtube* $mol_icon_youtube
	Icon_instagram* $mol_icon_instagram
	Icon_web* $mol_icon_web
	Product_undo* $mol_button_major
		title @ \Undo
		click? <=> product_undo*? null
	plugins /
		<= Theme_auto $bog_theme_auto
			themes /
				\$mol_theme_light
				\$mol_theme_dark
		<= Ico $bog_favicon
			Icon <= ico $mol_icon_all_inclusive
		<= Undo_hotkey $mol_hotkey2
			action *
				ctrl_Z? <=> undo_last? null
	head /
		<= Hero $mol_view
			sub <= hero_sub /
				<= Profile $mol_view
					sub /
						<= Avatar $mol_view
							style <= avatar_style *
							attr *
								bog_merchquarium_app_avatar_empty <= avatar_empty true
						<= Nick $mol_paragraph
							title <= title
				<= Socials $mol_view
					sub /
						<= Socials_label $mol_paragraph
							title @ \I have
						<= Socials_list $mol_view
							sub <= socials /
		<= Title
		<= Product_add $bog_merchquarium_button
			title @ \Add product
			click? <=> product_add? null
			hidden <= not_editing true
		<= Tools
	tools /
		<= Help_button $mol_check_icon
			hint @ \How it works
			Icon <= Help_icon $mol_icon_help_circle_outline
			checked? <=> help_checked? false
		<= Preview $mol_check_icon
			hint @ \How visitors see it
			Icon <= Preview_icon $mol_icon_eye_outline
			checked? <=> preview? false
		<= Cart_button $mol_button_minor
			hint @ \Cart
			click? <=> cart_toggle? null
			sub /
				<= Cart_icon $mol_icon_basket
				<= Cart_size $mol_view
					sub /
						<= cart_size_text \
		<= Lights $bog_theme_toggle
			theme_auto <= Theme_auto
		<= Settings_button $mol_button_minor
			hint <= settings_button_title \
			click? <=> settings_toggle? null
			sub <= settings_button_sub /
				<= Settings_icon $mol_icon_cog
				<= Return_icon $mol_icon_arrow_left
	body <= content /
		<= Catalog_missing $bog_merchquarium_start
			create? <=> catalog_create? null
		<= Catalog_selected $mol_list
			rows <= catalog_rows /
				<= Product_all $mol_button_minor
					title @ \← Whole catalog
					click? <=> product_all? null
				<= Filters $mol_view
					sub <= filters /
						<= Kind_filter $mol_select
							dictionary <= kind_options *
							value? <=> category_filter? \all
						<= Fandom_filter $mol_select
							dictionary <= fandom_options *
							value? <=> fandom_filter? \all
						<= In_stock $mol_check_box
							title @ \Only in stock
							checked? <=> in_stock_only? false
						<= Search $mol_search
							query? <=> search? \
				<= Product_cards $bog_merchquarium_gallery
					items <= product_cards /
				<= Catalog_empty $mol_paragraph
					title @ \Products coming soon
		<= Help $bog_merchquarium_help
			settings? <=> help_settings? null
		<= Settings $bog_merchquarium_settings
			catalog_link <= catalog_link \
		<= Cart $bog_merchquarium_cart
			catalog_link <= catalog_link \
			items? <=> cart? *
			back? <=> cart_close? null
		<= Order $bog_merchquarium_cart
			catalog_link <= catalog_link \
			items <= order_items *
			editable false
			back? <=> cart_close? null
